import { useEffect, useState } from 'react';

const useTransition = (target: string, time: number) => {
  const [value, setValue] = useState<string>();

  useEffect(() => {
    setValue(undefined);
    const timer = setTimeout(() => setValue(target), time);

    return () => clearTimeout(timer);
  }, [target, time]);

  return value;
};

export default useTransition;
